/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeResponseSchema } from './availabilityRangeResponseSchema';

export const availabilityRangeBulkCreateResponseSchema = z.object({
  get ranges() {
    return z.array(availabilityRangeResponseSchema);
  },
  skippedCount: z.int(),
});
